import {
  useLayoutEffect,
  useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { cloneDeep } from 'lodash';
import { isEmpty } from 'util/isEmpty';

const useGetClassData = (classId = "", path = "", def?:any) => {

    const [data ,setData] = useState(null);
    const [stepData, setStepData] = useState(null);

    const getClassData = async () => {
        if(isEmpty(classId)) return;
        const result = await classesAPI.getClassById(classId, null)
        .then(res => {
            return res?.data
        })        
        setData(cloneDeep(result))        
    }

    const getClassStepData = async () => {
        if(isEmpty(classId)) return;
        const result = await classesAPI[path](classId, null)
        .then((res:any) => {
            return res?.data
        });

        setStepData(cloneDeep(result))
    }

    useLayoutEffect(()=>{
        getClassData()
        getClassStepData()
    },[classId, def])

    return { data, stepData }

}
export default useGetClassData;

